import React from 'react';
import { useSelector } from 'react-redux';
import DimensionCombination from '../DimensionCombination';
import AddDimensionPopup from '../AddDimensionPopup';
import {
  DimensionTitle,
  DimensionWrapper,
  ListWrapper,
  PointerIconRing,
  ScanTitle
} from '../styled';
import ChevronIcon from '@src/icons/aiAlerts/right-chevron.svg'
import { getCardinalityText, getDimensionList, isAdvanceCustomerType, isFirstDimension, shouldDisplayAddDim, transformDimensionList } from '../alertConfig.utils';
import { aiAlertsAddCustomDimensionsSelector, aiAlertsConfigSelector, aiAlertsCustomDimensionsUpperLimitLevel1Selector, aiAlertsCustomDimensionsUpperLimitLevel2Selector, aiAlertsCustomDimensionsUpperLimitLevel3Selector, aiAlertsDimensionMappingSelector } from '@store/common/selectors';

export default function DimensionGroup({ aiConfigList, customerType }) {
  const isConfigFeatureEnabled = useSelector(aiAlertsConfigSelector);
  const isCustomDimensionAdditionEnabled = useSelector(aiAlertsAddCustomDimensionsSelector);
  const maxCount = {
    1: useSelector(aiAlertsCustomDimensionsUpperLimitLevel1Selector),
    2: useSelector(aiAlertsCustomDimensionsUpperLimitLevel2Selector),
    3: useSelector(aiAlertsCustomDimensionsUpperLimitLevel3Selector),
  }
  const aiDimensionMapping = useSelector(aiAlertsDimensionMappingSelector);
  const dimensionList = getDimensionList(aiConfigList, aiDimensionMapping);
  const singleDimensionList = transformDimensionList(aiDimensionMapping, aiConfigList);
  const displayAddDimensionBtn = isConfigFeatureEnabled && isCustomDimensionAdditionEnabled && isAdvanceCustomerType(customerType);

  return aiConfigList
    .filter(({ level }) => level > 0)
    .map((currentLevel) => {
      const { level, totalCombinations, dimensionData } = currentLevel;
      const isSingleDimension = isFirstDimension(level);
      const dimensionText = `${isSingleDimension ? 'Single' : level} Dimension${isSingleDimension ? '' : 's'}`;

      return (
        <li key={level}>
          <ListWrapper>
            <PointerIconRing isSubPointer margin="0 12px 0 0"><ChevronIcon /></PointerIconRing>
            <div>
              <DimensionTitle>{dimensionText}</DimensionTitle>
              <ScanTitle>(Scanning {getCardinalityText(totalCombinations, 2)})</ScanTitle>
            </div>
          </ListWrapper>
          <DimensionWrapper displayAddDimension={displayAddDimensionBtn}>
            {shouldDisplayAddDim(displayAddDimensionBtn, dimensionData, maxCount[level]) &&
              <AddDimensionPopup
                level={level}
                dimensionText={dimensionText}
                dimensionList={level === 1 ? singleDimensionList : dimensionList}
                dimensionData={dimensionData}
                aiConfigList={aiConfigList}
              />}
            <DimensionCombination level={level} combinations={dimensionData}  />
          </DimensionWrapper>
        </li>
      );
  })
}
